import { APIErrorInterface } from '../../../store/types';
import { AUTH_FAILED_ERROR } from '../../../store/types/AuthFaultCode';

export const getErrorsMsg = function (
    formError?: string,
    apiErrors?: APIErrorInterface | null,
): string {
    let msg = '';
    if (formError) {
        msg = formError;
    } else if (apiErrors) {
        msg = 'emptyInput';
    }
    return msg;
};

export type LoginFormField = 'login' | 'password';

/**
 * Sign-in never reveals which of the two credentials was wrong, so a failed
 * authentication marks both inputs. Every other faultcode — a blocked account,
 * brute-force protection, an internal error — says nothing about what the user
 * typed and has to leave the inputs untouched; those messages reach the user
 * through the snackbar instead.
 */
const API_FIELD_MESSAGES: Record<
    string,
    Partial<Record<LoginFormField, string>>
> = {
    [AUTH_FAILED_ERROR]: {
        login: 'emptyInput',
        password: 'emptyInput',
    },
};

export const getLoginFieldError = function (
    field: LoginFormField,
    formError?: string,
    apiErrors?: APIErrorInterface | null,
): string {
    if (formError) {
        return formError;
    }

    return (apiErrors && API_FIELD_MESSAGES[apiErrors.faultcode]?.[field]) || '';
};
